import "./page_styles/FittingFooterStyles.css"; // Add a CSS file for styles
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer.js";
import TransferForm from "../components/Prescription/PrescriptionForms/TransferForm.js";
import { useLocation } from "react-router-dom";

function TransferPage() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="page-container">
      <div className="content-wrap">
        <TransferForm />
      </div>
    </div>
  );
}

export default TransferPage;
